import styled from 'styled-components';

export const Separator = styled.div`
  width: 100%;
  height: 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray};
`;
